import { admin } from 'controllers/admin';
import { hotel } from 'controllers/hotel';

export const controllers = [...admin, ...hotel];
